var _paq = _paq || [];
var _piwikReady = false;
var piwik = {
    id: 0,
    url: "//stats.enwoxsystems.cz/",
    isLoggedIn: false,
    username: "",
    businessSubjects: [],
    send: function () {
        _paq.push(['setCustomVariable', 1, "isLoggedIn", this.isLoggedIn, "visit"]);
        if (this.isLoggedIn) {
            _paq.push(['setCustomVariable', 2, "user", this.username, "visit"]);
            _paq.push(['setCustomVariable', 3, "businessSubjects", this.businessSubjects, "visit"]);
        }
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function () {
            _paq.push(['setTrackerUrl', piwik.url + 'piwik.php']);
            _paq.push(['setSiteId', piwik.id]);
            var u = piwik.url, d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            if (!_piwikReady) {
                g.type = 'text/javascript';
                g.async = true;
                g.defer = true;
                g.src = u + 'piwik.js';
                s.parentNode.insertBefore(g, s);
                _piwikReady = true;
            }
        }());
    }
};
